import { TypoTooltip } from "@data-display/wrapper/DetectOverflow";
import type { ITypoTooltipProps } from "@data-display/wrapper/DetectOverflow/TypoTooltip";
import { type StackProps, Typography, type TypographyProps } from "@mui/material";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import type React from "react";
import type { ReactNode } from "react";

export interface ILabelInfoProps extends TypographyProps {
  label: string;
  text: string | React.ReactNode;
  tooltip?: ReactNode;
  hidden?: boolean;
  className?: string;
  color?: SvgIconProps["color"];
  noWrap?: boolean;
  slotProps?: {
    stack?: Partial<StackProps>;
    label?: Partial<TypographyProps>;
    typography?: Partial<ITypoTooltipProps>;
  };
}

export const LabelInfo = ({
  label,
  text,
  tooltip,
  hidden,
  className,
  color,
  noWrap,
  slotProps,
  ...props
}: ILabelInfoProps) => {
  if (hidden) {
    return null;
  }

  return (
    <Typography
      className={className}
      {...props}
      sx={[
        {
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <Typography variant="body1SemiBold" {...slotProps?.label}>
        {label} :{" "}
      </Typography>
      <TypoTooltip
        tooltip={tooltip}
        variant="body1"
        lineHeight={1.2}
        noWrap={noWrap}
        display="inline"
        {...slotProps?.typography}
      >
        {text}
      </TypoTooltip>
    </Typography>
  );
};
